<template>
  <section class="rounded-xl" :class="footerClass">
    <!-- One line at every width: the long parts drop out on a phone. -->
    <section
      class="flex justify-between items-center gap-2 whitespace-nowrap text-xs font-semibold px-2 py-0.5"
      data-test="footer-row"
    >
      <section class="flex items-center space-x-1 min-w-0">
        <span>©</span>
        <span class="truncate">
          <span class="hidden sm:inline" data-test="footer-long">2000 -</span>
          {{ new Date().getFullYear() }} Praxes
          <span class="hidden sm:inline" data-test="footer-long">Medical Group</span>
        </span>
      </section>
      <section>
        Version {{ appVersion }}
        <span class="hidden sm:inline" data-test="footer-long">({{ buildDate }})</span>
      </section>
    </section>
  </section>
</template>

<script setup lang="ts">
/* global __APP_VERSION__, __BUILD_DATE__ -- build-time constants from vite.config.ts */
import { computed } from 'vue';

// Computed
const footerClass = computed(() => {
  return 'bg-red-600 text-white';
});

const appVersion = __APP_VERSION__;
const buildDate = __BUILD_DATE__;
</script>

<style scoped></style>
